'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function MUFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-k7a8v16ec", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-3fsvtxfei", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-risynkins" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-risynkins", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-k7a8v16ec)" }, /* @__PURE__ */ React.createElement("use", { fill: "#579d20", xlinkHref: "#mantine-risynkins" }), /* @__PURE__ */ React.createElement("path", { fill: "#feca00", d: "M0 12h32v6H0z", mask: "url(#mantine-3fsvtxfei)" }), /* @__PURE__ */ React.createElement("path", { fill: "#3d58db", d: "M0 6h32v6H0z", mask: "url(#mantine-3fsvtxfei)" }), /* @__PURE__ */ React.createElement("path", { fill: "#e11c1b", d: "M0 0h32v6H0z", mask: "url(#mantine-3fsvtxfei)" })))
  );
}

export { MUFlag };
//# sourceMappingURL=MU.mjs.map
